export const UnitConstants = {
    GET_UNIT_SUCCEEDED: 'GET_UNIT_SUCCEEDED',
    GET_MOVED_IN_PROPERTY_SUCCEEDED: 'GET_MOVED_IN_PROPERTY_SUCCEEDED',
    GET_PENDING_PROPERTY_SUCCEEDED: 'GET_PENDING_PROPERTY_SUCCEEDED',
};